<div class="qi-wrap">
  <a class="toolbar-toggle qi-chip" (click)="toggle()" data-bs-toggle="tooltip"
     title="Booking queue" [class.qi-alert]="failed() > 0">
    <span><i class="fa fa-tasks fa-2x qi-icon"></i></span>
    @if (failed() > 0) {
      <span class="qi-badge qi-badge-failed">{{ failed() }}</span>
    } @else if (active() > 0) {
      <span class="qi-badge qi-badge-active">{{ active() }}</span>
    } @else if (unreachable()) {
      <span class="qi-badge qi-badge-unknown">?</span>
    }
  </a>

  @if (open()) {
    <div class="qi-backdrop" (click)="close()"></div>
    <div class="qi-panel" role="dialog" aria-label="Booking queue status">
      <div class="qi-panel-header">
        <b>Booking queue</b>
        <button type="button" class="btn-close btn-close-sm ms-auto" aria-label="Close" (click)="close()"></button>
      </div>

      <div class="qi-counts">
        <div class="qi-count">
          <div class="qi-count-value">{{ pending() }}</div>
          <div class="qi-count-label">Pending</div>
        </div>
        <div class="qi-count">
          <div class="qi-count-value">{{ processing() }}</div>
          <div class="qi-count-label">Processing</div>
        </div>
        <div class="qi-count" [class.qi-count-failed]="failed() > 0">
          <div class="qi-count-value">{{ failed() }}</div>
          <div class="qi-count-label">Failed</div>
        </div>
      </div>

      @if (unreachable()) {
        <div class="qi-note qi-note-warn">Queue status could not be fetched — server unreachable?</div>
      } @else if (failed() === 0 && active() === 0) {
        <div class="qi-note">All bookings saved — the queue is empty.</div>
      } @else if (active() > 0 && failed() === 0) {
        <div class="qi-note">Queued bookings are being saved in the background.</div>
      }

      @if (failed() > 0) {
        <div class="qi-failed-title">Failed bookings (need attention)</div>
        @if (loadingFailed()) {
          <div class="qi-note">Loading…</div>
        } @else {
          <ul class="qi-failed-list">
            @for (row of failedList(); track row.id) {
              <li class="qi-failed-row">
                <div class="qi-failed-info">
                  <div class="qi-failed-name">
                    {{ row.familyName || row.bookingRefId }}
                    <span class="qi-muted">· counter {{ row.counter }} · {{ row.attempts }} attempts</span>
                  </div>
                  <div class="qi-failed-error" [title]="row.errorMessage">{{ row.errorMessage }}</div>
                </div>
                <div class="qi-failed-actions">
                  <button type="button" class="btn btn-sm btn-outline-primary"
                          [disabled]="busyId() === row.id" (click)="requeue(row)"
                          title="Try saving this booking again">Requeue</button>
                  <button type="button" class="btn btn-sm"
                          [class.btn-outline-danger]="confirmDiscardId() !== row.id"
                          [class.btn-danger]="confirmDiscardId() === row.id"
                          [disabled]="busyId() === row.id" (click)="discard(row)"
                          title="Abandon this booking and release its reserved limited-pooja capacity">
                    {{ confirmDiscardId() === row.id ? 'Confirm?' : 'Discard' }}
                  </button>
                </div>
              </li>
            }
          </ul>
        }
      }
    </div>
  }
</div>
